(function () {
  'use strict';
  if (window.KjsCartControls) return;
  var state = window.KjsCartControls = { busy: false };
  var surfaces = '#KjsCartForm, .mfp-wrap .cart_menu';
  var controls = '.plus_btn, .minus_btn, .remove_item_button';
  var inputTimer;
  function root(path) {
    return (window.Shopify.routes.root || '/').replace(/\/?$/, '/') + path;
  }
  async function request(path, body) {
    var response = await fetch(root(path), {
      method: body ? 'POST' : 'GET', credentials: 'same-origin', cache: 'no-store',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: body ? JSON.stringify(body) : undefined, signal: AbortSignal.timeout(12000)
    });
    if (!response.ok) throw Error('Cart request rejected');
    return response.json();
  }
  function lock(value) {
    state.busy = value;
    document.querySelectorAll('kjs-delivery-picker').forEach(function (picker) { if (picker.render) picker.render(); });
    document.querySelectorAll('#KjsCartForm .number_val_input, .mfp-wrap .cart_menu .number_val_input').forEach(function (input) { input.disabled = value; });
  }
  function showError(form) {
    var message = form.querySelector('[data-kjs-cart-update-error]');
    if (!message) {
      message = document.createElement('p');
      message.setAttribute('data-kjs-cart-update-error', '');
      message.setAttribute('role', 'alert');
      form.prepend(message);
    }
    message.textContent = document.body.getAttribute('data-kjs-cart-error');
  }
  async function refreshPageCart() {
    var form = document.querySelector('#KjsCartForm');
    if (!form || state.busy || document.querySelector('kjs-delivery-picker[aria-busy="true"]')) return;
    if (typeof window.Shopify?.updateQuickCart !== 'function') return;
    clearTimeout(inputTimer);
    lock(true);
    try {
      var cart = await request('cart.js');
      Shopify.updateQuickCart(cart);
      document.querySelectorAll('kjs-delivery-picker').forEach(function (picker) { if (picker.updateSubtotal) picker.updateSubtotal(cart); });
      document.querySelectorAll('[data-kjs-cart-update-error]').forEach(function (message) { message.remove(); });
    } catch (_) { showError(form); }
    finally { lock(false); }
  }
  async function openDrawer(link) {
    var jq = window.jQuery;
    if (!jq?.magnificPopup || typeof Shopify.updateQuickCart !== 'function') { location.assign(link.getAttribute('data-href') || root('cart')); return; }
    if (state.busy) return;
    lock(true);
    try {
      Shopify.updateQuickCart(await request('cart.js'));
      var menu = Array.from(document.querySelectorAll('.cart_menu')).find(function (node) { return !node.closest('.mfp-wrap'); });
      if (!menu) throw Error('Cart unavailable');
      jq.magnificPopup.open({items:{src:'<div class="mfp-with-anim modal-popup">'+menu.outerHTML+'</div>',type:'inline'},mainClass:'mfp-move-from-top kjs-cart-drawer',removalDelay:150,callbacks:{close:function(){document.documentElement.style.overflowY='auto';link.focus();}}});
      if (typeof window.bindEventsInCart === 'function') window.bindEventsInCart();
    } catch (_) { location.assign(link.getAttribute('data-href') || root('cart')); }
    finally { lock(false); }
  }
  async function update(control, absolute) {
    var row = control.closest('ul'), form = control.closest('form');
    var input = row && row.querySelector('.number_val_input');
    if (!form || !input || state.busy || document.querySelector('kjs-delivery-picker[aria-busy="true"]')) return;
    var key;
    try { key = decodeURIComponent(input.getAttribute('data-key') || ''); } catch (_) { showError(form); return; }
    if (!key || !window.Shopify || typeof Shopify.updateQuickCart !== 'function') { showError(form); return; }
    var entered = input.value.trim(), oldValue = input.defaultValue;
    if (absolute && (!/^\d+$/.test(entered) || !Number.isSafeInteger(Number(entered)))) { input.value = oldValue; showError(form); return; }
    var focusClass = control === input ? '.number_val_input' : control.classList.contains('plus_btn') ? '.plus_btn' : '.minus_btn';
    lock(true);
    try {
      var before = await request('cart.js');
      var item = before.items.find(function (line) { return line.key === key; });
      if (!item) throw Error('Cart line changed');
      var quantity = absolute ? Number(entered) : control.classList.contains('remove_item_button') ? 0 : Math.max(0, item.quantity + (control.classList.contains('plus_btn') ? 1 : -1));
      var cart = quantity === item.quantity ? before : await request('cart/change.js', { id: key, quantity: quantity });
      Shopify.updateQuickCart(cart);
      document.querySelectorAll('kjs-delivery-picker').forEach(function (picker) { if (picker.updateSubtotal) picker.updateSubtotal(cart); });
      document.querySelectorAll('[data-kjs-cart-update-error]').forEach(function (message) { message.remove(); });
      var actual = cart.items.find(function (line) { return line.key === key; });
      if ((actual ? actual.quantity : 0) !== quantity) showError(form);
      var nextInput = Array.from(document.querySelectorAll('.number_val_input[data-key]')).find(function (candidate) { return candidate.closest(surfaces) && candidate.getClientRects().length && candidate.getAttribute('data-key') === encodeURIComponent(key); });
      if (nextInput) {
        var nextControl = nextInput.closest('ul').querySelector(focusClass);
        if (nextControl) nextControl.focus();
      }
    } catch (_) {
      input.value = oldValue;
      showError(form);
    } finally { lock(false); }
  }
  function intercept(event, control, absolute) {
    if (!control || !control.closest(surfaces)) return;
    clearTimeout(inputTimer);
    event.preventDefault(); event.stopImmediatePropagation();
    update(control, absolute);
  }
  document.addEventListener('click', function (event) {
    var link = event.target.closest('.cart-popup');
    if (link && document.body.getAttribute('data-kjs-cart-type') === 'modal') { event.preventDefault();event.stopImmediatePropagation();openDrawer(link);return; }
    intercept(event, event.target.closest(controls), false);
  }, true);
  document.addEventListener('input', function (event) {
    var input=event.target.closest('.number_val_input');
    if (!input || !input.closest(surfaces)) return;
    clearTimeout(inputTimer);
    inputTimer=setTimeout(function(){if(input.isConnected)update(input,true);},450);
  }, true);
  document.addEventListener('change', function (event) { intercept(event, event.target.closest('.number_val_input'), true); }, true);
  document.addEventListener('keydown', function (event) {
    var input = event.target.closest('.number_val_input');
    if (input && event.key === 'Enter') { intercept(event, input, true); return; }
    var control = event.target.closest(controls);
    if (control && control.tagName === 'A' && (event.key === 'Enter' || event.key === ' ')) intercept(event, control, false);
  }, true);
  window.addEventListener('pageshow', refreshPageCart);
  if (document.readyState === 'complete') refreshPageCart();
}());
